import { Image } from '../Image/Image';
import styles from './AnswerItem.module.scss';
import cn from 'classnames';
export const AnswerItem = ({ children, type, status, className, ...props }) => {
  const { icon = null, answer, description = null } = children;
  return (
    <div className={cn(styles.item, className, status === 'active' && styles.active)} {...props}>
      {icon && <Image className={styles.icon} src={icon} alt={answer} />}
      <div className={cn(styles.text, icon && styles.alignStart)}>{answer}</div>
      {type == 'checkbox' &&
        <div className={styles.checkbox} >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect width="20" height="20" rx="6" fill="#7B35FE" />
            <path d="M13.5 7.5L9.24469 12L8.08156 10.9853L7 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      }
      {description && <div className={styles.description}>{description}</div>}
    </div>
  );
}
